import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';

export default class ByLine extends Component {
  shouldComponentUpdate() {
    return false;
  }

  renderAuthorLink() {
    const { bylineAttribution, post } = this.props;
    const { author } = post;

    if (bylineAttribution) {
      return `By ${bylineAttribution}`;
    }

    return <Link to={`/user/${author.slug}`}> By {author.name}</Link>;
  }

  render() {
    const { live } = this.props;
    const { readTime } = this.props.post;
    return (
      <div className="post__byline">
        <cite className="post__by">{this.renderAuthorLink()}</cite>
        {!live ? <span className="post__readTime">{readTime} Read</span> : null}
      </div>
    );
  }
}

ByLine.defaultProps = {
  live: false
};

ByLine.propTypes = {
  post: PropTypes.shape({
    tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    author: PropTypes.shape({}).isRequired,
    readTime: PropTypes.string.isRequired
  }).isRequired,
  bylineAttribution: PropTypes.string.isRequired,
  live: PropTypes.bool
};
